import cx from 'clsx';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';
import config from '@plone/volto/registry';
import { Section } from '../../Section/Section';
import type { SectionColor, SectionWidth } from '../../Section/Section';

export type SectionBlockData = {
  '@type': string;
  blocks?: Record<string, unknown>;
  blocks_layout?: { items: string[] };
  heading?: string;
  color?: SectionColor;
  width?: SectionWidth;
  flushBottom?: boolean;
};

type SectionViewProps = {
  data: SectionBlockData;
  path?: string;
  className?: string;
  style?: React.CSSProperties;
  metadata?: unknown;
  properties?: unknown;
  blocksConfig?: unknown;
};

/**
 * View do bloco Section: faixa de cor full-bleed com blocos aninhados
 * dentro de um Container (mesmo desenho do Grid/View.jsx do core,
 * mas vertical). Ver docs/specs/blocks/section.md.
 */
const SectionView = (props: SectionViewProps) => {
  const { data, path, className, style } = props;
  const metadata = props.metadata || props.properties;

  if (data.blocks_layout === undefined) {
    return null;
  }

  const blocksConfig =
    config.blocks.blocksConfig[data['@type']].blocksConfig ||
    props.blocksConfig;

  return (
    <Section
      className={cx('block-section', className, {
        'odc-section--flush-bottom': data.flushBottom,
        'odc-section--has-heading': !!data.heading,
      })}
      color={data.color ?? 'brand'}
      width={data.width ?? 'default'}
      style={style}
    >
      {data.heading && <h2 className="section__heading">{data.heading}</h2>}
      <RenderBlocks
        {...props}
        metadata={metadata}
        content={data}
        location={{ pathname: path }}
        blocksConfig={blocksConfig}
        isContainer
      />
    </Section>
  );
};

export default SectionView;
